import type {ColumnModel} from '../../../models/column-model'
import type {GroupId} from '../../../state-providers/memex-items/queries/query-keys'
import type {Row} from './types'

/**
 * Overrides the default getRowId function from react-table.
 * Provides a more stable row id based on the item's id instead
 * of the row index.
 * https://tanstack.com/table/latest/docs/api/core/table#getrowid
 */
export function getRowId<T extends {id: string | number}>(
  item: Pick<T, 'id'>,
  _index: number,
  parent?: Pick<Row<T>, 'id'>,
): string {
  const itemId = item.id.toString()
  return parent ? subRowId(itemId, parent.id) : itemId
}

// The same item may appear in multiple groups, so we include the
// parent row id in the sub row id to ensure uniqueness.
const subRowId = (rowId: string, parentId: string) => `${parentId}-${rowId}`

// The groupId should be sufficiently unique on its own. We should explore
// whether adding `columnModelId` is necessary here.
export const groupedRowId = (columnModelId: ColumnModel['id'], groupId: GroupId) => {
  return `${columnModelId}:${groupId}`
}
